const validPlayer = (player) => player && typeof player.ESS === 'string' && player.ESS.trim() !== '';

const normalizedESS = (player) => {
    if (!validPlayer(player)) {
        return '';
    }
    return player.ESS.trim();
};

const playerSortKey = (player) => {
    const ess = normalizedESS(player);
    if (ess.length <= 2) {
        return ess.toLowerCase();
    }
    return ess.substring(2).toLowerCase();
};

export const sortPlayers = (players) => {
    return (players || [])
        .filter(validPlayer)
        .slice()
        .sort((left, right) => {
            const leftKey = playerSortKey(left);
            const rightKey = playerSortKey(right);
            if (leftKey !== rightKey) {
                return leftKey.localeCompare(rightKey);
            }
            return normalizedESS(left).localeCompare(normalizedESS(right));
        });
};

export const applyPlayersMessage = (currentPlayers = [], message) => {
    if (Array.isArray(message)) {
        return {type: 'snapshot', changed: true, players: sortPlayers(message)};
    }
    if (!message || typeof message !== 'object') {
        return {type: 'ignored', changed: false, players: currentPlayers};
    }
    if (message.type === 'heartbeat') {
        return {type: 'heartbeat', changed: false, players: currentPlayers};
    }
    if (message.type === 'snapshot' && Array.isArray(message.egms)) {
        return {type: 'snapshot', changed: true, players: sortPlayers(message.egms)};
    }
    if (message.type === 'delta' && Array.isArray(message.egms)) {
        if (message.egms.length === 0) {
            return {type: 'delta', changed: false, players: currentPlayers};
        }
        const byESS = new Map(sortPlayers(currentPlayers).map((player) => [normalizedESS(player), player]));
        for (const player of message.egms) {
            const ess = normalizedESS(player);
            if (!ess) {
                continue;
            }
            byESS.set(ess, player);
        }
        return {type: 'delta', changed: true, players: sortPlayers(Array.from(byESS.values()))};
    }
    return {type: 'ignored', changed: false, players: currentPlayers};
};
